module.exports = __webpack_public_path__ + "img/frame (180).dcebd271.jpg";